const { includes, lowerCase, round } = require('lodash');

const restrictionTypes = {
    NONE: 'NONE',
    PM_DELIVERY: 'PM_DELIVERY',
    DELIVERY_ONLY: 'DELIVERY_ONLY',
    COLLECTION_ONLY: 'COLLECTION_ONLY',
    EXPRESS_DELIVERY_ONLY: 'EXPRESS_DELIVERY_ONLY',
};

class BbProductTileController {
    constructor(dialogRegistry, config, settings, trolleyService, ratingService, analyticsService, $state, $sce, $window) {
        this.dialogRegistry = dialogRegistry;
        this.config = config;
        this.settings = settings;
        this.trolleyService = trolleyService;
        this.ratingService = ratingService;
        this.analyticsService = analyticsService;
        this.restrictionTypes = restrictionTypes;
        this.$state = $state;
        this.$sce = $sce;
        this.$window = $window;
    }

    $onInit() {
        this.productRestriction = this.getRestriction();
        this.shouldShowSavingsTag = this.product.IsOnSpecial && this.product.HasHeaderTag && this.product.HeaderTag.Promotion !== 'Special' && this.product.SavingsAmount > 0;

        if (this.productRestriction === 'PM_DELIVERY') {
            this.restrictionDelivery = this.product.ProductRestrictionMessage;
        }

        if (this.productRestriction === 'DELIVERY_ONLY') {
            this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionDeliveryOnly;
        }

        if (this.productRestriction === 'COLLECTION_ONLY') {
            this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionPickUpOnly;
        }

        if (this.productRestriction === 'EXPRESS_DELIVERY_ONLY') {
            this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionExpressDeliveryOnly;
        }

        // This is a hack for showing centre tags if the special is a multibuy (multibuys don't have tag content containing the word 'was')
        this.centreTagContainsWas = includes(lowerCase(this.product.CentreTag.TagContent), 'was');

        this.shouldShowCentreTag = this.product.IsCentreTag && !this.product.IsDeliveryPass && (!this.product.IsOnSpecial || !this.centreTagContainsWas);

        this.stars = this.product.Rating && this.product.Rating.Average ? this.ratingService.populateStars(round(this.product.Rating.Average, 1)) : [];
        this.hasRating = !!this.product.Rating && this.product.Rating.RatingCount >= this.settings.ratingreview.minRatingCount;

        this.isShowSaveToList = this.showSaveToList !== undefined ? this.showSaveToList : true;
        this.isEnableNavigateToDetailPage = this.enableNavigateToDetailPage !== undefined ? this.enableNavigateToDetailPage : true;

        this.expanded = false;
    }

    getRestriction() {
        if (this.product.IsPmDelivery) {
            return this.restrictionTypes.PM_DELIVERY;
        } else if (this.product.IsForCollection && !this.product.IsForDelivery && !this.product.IsForExpress) {
            return this.restrictionTypes.COLLECTION_ONLY;
        } else if (!this.product.IsForCollection && this.product.IsForDelivery && !this.product.IsForExpress) {
            return this.restrictionTypes.DELIVERY_ONLY;
        } else if (!this.product.IsForCollection && !this.product.IsForDelivery && this.product.IsForExpress) {
            return this.restrictionTypes.EXPRESS_DELIVERY_ONLY;
        }

        return this.restrictionTypes.NONE;
    }

    pushStarRatingClickEventToAnalytics() {
        this.analyticsService.push({
            data: {
                event: {
                    category: 'Ratings&Reviews',
                    label: 'Star Ratings',
                },
                trackingType: 'link',
            },
            type: this.analyticsService.mapperTypes.customEvent.linkClick,
        });
    }

    pushProductClickEventToAnalytics() {
        this.analyticsService.push({
            data: {
                trackingType: 'link',
                product: this.product,
            },
            type: this.analyticsService.mapperTypes.customEvent.productClick,
        });
    }

    productDetailNavigation() {
        if (this.isEnableNavigateToDetailPage) {
            this.$state.go(
                'shop.productdetails',
                {
                    productId: this.product.Stockcode,
                    productName: this.product.UrlFriendlyName,
                    product: this.product,
                },
                {
                    inherit: false,
                    reload: false,
                },
            );
        }
    }

    shouldConfirmAddToCart() {
        return this.settings.carePackage.addToCartConfirmation && !this.product.IsInTrolley && this.trolleyService.itemCount > 0;
    }

    confirmAddToCart() {
        this.loading = true;
        this.trolleyService.addItemToTrolley(this.product, 1, this.product.Source, undefined).then(() => {
            this.loading = false;
            this.product.IsInTrolley = true;
            this.product.QuantityInTrolley = 1;
            this.dismissCartConfirmationModal();
        });
    }

    openCartConfirmationModal() {
        const dialog = this.dialogRegistry.getDialog('cartConfirmation dialog');
        if (dialog) {
            dialog.show();
        }
    }

    dismissCartConfirmationModal() {
        const dialog = this.dialogRegistry.getDialog('cartConfirmation dialog');
        if (dialog) {
            dialog.close();
        }
    }
}

const bbProductTileComponentDefinition = {
    bindings: {
        product: '<',
        showSaveToList: '<?',
        enableNavigateToDetailPage: '<?',
    },
    controller: ['DialogRegistry', 'config', 'Settings', 'TrolleyService', 'RatingService', 'AnalyticsService', '$state', '$sce', '$window', BbProductTileController],
    template: require('./bb-product-tile.component.html').trim(),
};

module.exports = {
    BbProductTileController,
    bbProductTileComponentDefinition,
};




// WEBPACK FOOTER //
// ./src/shop/shelfproduct/bb-product-tile.component.js